import React from "react";
import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../../Components/CustomComponents";
import styles from "../styles/campaignNotifications.module.scss";

export default function CampaignListHeader({
  categories = [],
  categoryFilter,
  onCategoryChange,
}) {
  return (
    <div className={styles.headerContainer}>
      <Row className="w-100 align-items-center">
        <Col md={7}>
          <div className={styles.headerCopy}>
            <SubTitle text={"Campaign Notifications"} classes="primary-text" />
            <p className={styles.hint}>
              Seeded campaigns stay read-only. Edit notification copy or send to
              selected users.
            </p>
          </div>
        </Col>
        <Col md={5} className="d-flex justify-content-md-end mt-3 mt-md-0">
          <select
            className={styles.filterSelect}
            value={categoryFilter}
            onChange={(event) => onCategoryChange(event.target.value)}
            aria-label="Filter by category"
          >
            <option value="">All categories</option>
            {categories.map((category) => (
              <option key={category} value={category}>
                {category.replace(/_/g, " ")}
              </option>
            ))}
          </select>
        </Col>
      </Row>
    </div>
  );
}
